import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function PhotoCameraOff({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>PhotoCameraOff</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.15217 6.06639C6.95832 6.18493 6.73319 6.25 6.5 6.25H5C3.48122 6.25 2.25 7.48122 2.25 9V18C2.25 19.5188 3.48122 20.75 5 20.75H19C19.7948 20.75 20.5109 20.4128 21.0129 19.8737C20.9341 19.8296 20.8599 19.7741 20.7929 19.7071L19.9257 18.84C19.6971 19.0918 19.367 19.25 19 19.25H5C4.30964 19.25 3.75 18.6904 3.75 18V9C3.75 8.30964 4.30964 7.75 5 7.75H6.5C7.1349 7.75 7.74262 7.53074 8.2264 7.14061L7.15217 6.06639ZM9.84939 8.76361C8.30679 9.54827 7.25 11.1507 7.25 13C7.25 15.6234 9.37665 17.75 12 17.75C13.8493 17.75 15.4517 16.6932 16.2364 15.1506L15.0914 14.0056C14.6679 15.3083 13.4439 16.25 12 16.25C10.2051 16.25 8.75 14.7949 8.75 13C8.75 11.5561 9.69165 10.3321 10.9944 9.90858L9.84939 8.76361ZM12.1671 8.25288L16.7471 12.8329C16.661 10.3424 14.6576 8.33899 12.1671 8.25288ZM20.25 16.3358V9C20.25 8.30964 19.6904 7.75 19 7.75H17.5C16.6344 7.75 15.8193 7.34247 15.3 6.65L14.25 5.25C14.0139 4.93524 13.6434 4.75 13.25 4.75H10.75C10.3566 4.75 9.98607 4.93524 9.75 5.25L9.49895 5.58474L8.42752 4.51331L8.55 4.35C9.06935 3.65753 9.88442 3.25 10.75 3.25H13.25C14.1156 3.25 14.9307 3.65753 15.45 4.35L16.5 5.75C16.7361 6.06476 17.1066 6.25 17.5 6.25H19C20.5188 6.25 21.75 7.48122 21.75 9V17.8358L20.25 16.3358Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M3 3L21 21"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
